import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { getOpenCloseAnimation, ToastComponent, NotificationModule } from '@inst-iot/bosch-angular-ui-components';

const openStyle = {
    color: 'black'
};

const closedStyle = {
    height: '0',
    overflow: 'hidden',
    marginBottom: '16px',
    color: 'transparent'
};

@Component({
    selector: 'rb-notification-toast',
    templateUrl: './notification-toast.component.html',
    animations: [getOpenCloseAnimation(openStyle, closedStyle)],
    standalone: true,
    imports: [CommonModule, NotificationModule]
})

export class NotificationToastComponent extends ToastComponent {
    @Input() margin = '0px';
    @Input() type: 'error' | 'success' | 'neutral' = 'neutral';
    constructor() {
        super();
    }
}